import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Overlay } from "@/components/Overlay";
import { useApp } from "@/context/AppContext";
import { BuyTab } from "@/components/store/BuyTab";
import { RedeemTab } from "@/components/store/RedeemTab";
import { HistoryTab } from "@/components/store/HistoryTab";

export function StoreModal() {
  const { store, closeStore, setStore } = useApp();
  return (
    <Overlay open={store.open} onClose={closeStore} testId="store-modal" className="max-w-2xl min-h-[85vh] sm:min-h-0">
      <div className="py-4 border-b border-white/5 bg-[#1F2633]/60">
        <h2 className="text-center font-display text-xl font-bold">Store</h2>
      </div>
      <Tabs value={store.tab} onValueChange={(v) => setStore((s) => ({ ...s, tab: v }))} className="p-4 sm:p-6">
        <TabsList className="w-full grid grid-cols-3 bg-[#0B0E14]/70 border border-white/5 rounded-xl h-12 p-1">
          {["buy", "redeem", "history"].map((t) => (
            <TabsTrigger key={t} value={t} data-testid={`store-tab-${t}`} className="rounded-lg font-display font-bold tracking-wide uppercase text-gray-400 data-[state=active]:bg-[#1F2633] data-[state=active]:text-white">
              {t}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="buy" className="mt-5"><BuyTab /></TabsContent>
        <TabsContent value="redeem" className="mt-5"><RedeemTab /></TabsContent>
        <TabsContent value="history" className="mt-5"><HistoryTab /></TabsContent>
      </Tabs>
    </Overlay>
  );
}
